
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getCompanySet, modifyCompanySet } from '@/api/system';

@Component({
  name: 'SettingTemplateOrder',
  components: {

  }
})
export default class extends Vue {
  private deviceChecked = false
  private deviceSNChecked = false
  private deviceSerialChecked = false
  private deviceNameChecked = false

  created() {
    this.getCompanySet()
  }
  private getCompanySet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params).then(res => {
      if (res.data && res.data.companySet) {
        this.deviceChecked = parseInt(res.data.companySet.is_list_show_device_info) === 1;
        let deviceArr = []
        if (res.data.companySet.list_show_device_info) {
          deviceArr = res.data.companySet.list_show_device_info.split(',')
        }

        this.deviceSNChecked = deviceArr.includes('sn');
        this.deviceSerialChecked = deviceArr.includes('number');
        this.deviceNameChecked = deviceArr.includes('name');
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private modifyCompanySet(pamars:any) {
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      ...pamars
    };
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      this.getCompanySet();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private save() {
    let params:any = {};
    params.is_list_show_device_info = this.deviceChecked ? '1' : '0';
    let deviceInfo = '';
    if (this.deviceSNChecked) {
      deviceInfo += 'sn,'
    }
    if (this.deviceSerialChecked) {
      deviceInfo += 'number,'
    }
    if (this.deviceNameChecked) {
      deviceInfo += 'name'
    }
    if (!deviceInfo && this.deviceChecked) {
      this.showErrorMsg('请选择显示设备信息');
      return;
    }
    params.list_show_device_info = deviceInfo;
    this.modifyCompanySet(params);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}

